<div class="back-btn">
  <span class="material-icons">keyboard_arrow_left</span>
  <a routerLink="/login" class="back-btn" data-testid="register-back-to-login-link">Return To Login</a>
</div>
<div class="login-container">
  <a routerLink="/" data-testid="register-logo-link"><img class="login-logo" src="../../assets/img/logo.png" alt="logo" /></a>
  <div id="Create-Account">
    <form [formGroup]="createAccount">
      <div class="title">Create Account</div>
      <hr />
      <div class="create-form">
        <div class="form-control">
          <span class="form-label">First Name <span class="req">*</span></span>
          <input id="firstName" type="text" class="input" formControlName="firstName" maxlength="50"
            autocomplete="disabled" data-testid="register-firstname" />
          <div *ngIf="
              createAccount.controls['firstName']?.invalid &&
              (createAccount.controls['firstName'].dirty ||
                createAccount.controls['firstName'].touched)
            ">
            <div *ngIf="createAccount.controls['firstName'].errors?.['required']" class="error-message">
              First name is required.
            </div>
          </div>
        </div>
        <div class="form-control" style="margin-left: 10px">
          <span class="form-label">Last Name <span class="req">*</span></span>
          <input id="lastName" type="text" class="input" formControlName="lastName" maxlength="50"
            autocomplete="disabled" data-testid="register-lastname" />
          <div *ngIf="
              createAccount.controls['lastName']?.invalid &&
              (createAccount.controls['lastName'].dirty ||
                createAccount.controls['lastName'].touched)
            ">
            <div *ngIf="createAccount.controls['lastName'].errors?.['required']" class="error-message">
              Last name is required.
            </div>
          </div>
        </div>
      </div>
      <div class="create-form">
        <div class="">
          <span class="form-label">Email Address <span class="req">*</span></span>
          <input id="email" type="email" class="input" formControlName="email" maxlength="100"
            autocomplete="disabled" data-testid="register-email" />
          <div *ngIf="
              createAccount.controls['email']?.invalid &&
              (createAccount.controls['email'].dirty ||
                createAccount.controls['email'].touched)
            ">
            <div class="error-message" *ngIf="createAccount.controls['email'].errors?.['required']">
              Email is required.
            </div>
            <div *ngIf="
                createAccount.controls['email'].value != '' &&
                !createAccount.controls['email'].value?.match(emailRegx)
              " class="error-message">
              Please enter a valid email.
            </div>
          </div>
        </div>
      </div>
      <div class="create-form">
        <div class="">
          <span class="form-label">Phone <span class="req">*</span></span>
          <input id="phone" type="tel" class="input" formControlName="phone" maxlength="20"
            autocomplete="off" data-testid="register-phone" />
          <div *ngIf="
              createAccount.controls['phone']?.invalid &&
              (createAccount.controls['phone'].dirty ||
                createAccount.controls['phone'].touched)
            ">
            <div *ngIf="createAccount.controls['phone'].errors?.['required']" class="error-message">
              Phone is required.
            </div>
          </div>
        </div>
      </div>
      <div class="create-form">
        <div class="sms-optin">
          <label class="sms-optin-label">
            <input type="checkbox" formControlName="usePhoneForSms" aria-describedby="sms-optin-help" data-testid="register-sms-optin" />
            <span>Send me text message (SMS) notifications</span>
          </label>
          <span class="sms-optin-help" id="sms-optin-help">
            Standard message &amp; data rates may apply. We'll text you to confirm.
          </span>
        </div>
      </div>
      <ng-container formGroupName="location">
        <div class="create-form">
          <div class="">
            <span class="form-label">Street Address <span class="req">*</span></span>
            <input id="street" type="text" class="input" formControlName="street" maxlength="200"
              autocomplete="off" data-testid="register-street" />
            <div *ngIf="
                createAccount.get('location.street')?.invalid &&
                (createAccount.get('location.street')?.dirty ||
                  createAccount.get('location.street')?.touched)
              ">
              <div *ngIf="createAccount.get('location.street')?.errors?.['required']" class="error-message">
                Street address is required.
              </div>
            </div>
          </div>
        </div>
        <div class="create-form address-row">
          <div class="form-control">
            <span class="form-label">City <span class="req">*</span></span>
            <input id="city" type="text" class="input" formControlName="city" maxlength="100"
              autocomplete="off" data-testid="register-city" />
            <div *ngIf="
                createAccount.get('location.city')?.invalid &&
                (createAccount.get('location.city')?.dirty ||
                  createAccount.get('location.city')?.touched)
              ">
              <div *ngIf="createAccount.get('location.city')?.errors?.['required']" class="error-message">
                City is required.
              </div>
            </div>
          </div>
          <div class="form-control state-col" style="margin-left: 10px">
            <span class="form-label">State <span class="req">*</span></span>
            <select id="state" class="form-select" formControlName="state" data-testid="register-state">
              <option value="">Select a state</option>
              <option *ngFor="let s of states" [value]="s.code">{{ s.name }}</option>
            </select>
            <div *ngIf="
                createAccount.get('location.state')?.invalid &&
                (createAccount.get('location.state')?.dirty ||
                  createAccount.get('location.state')?.touched)
              ">
              <div *ngIf="createAccount.get('location.state')?.errors?.['required']" class="error-message">
                State is required.
              </div>
            </div>
          </div>
          <div class="form-control zip-col" style="margin-left: 10px">
            <span class="form-label">Zip Code <span class="req">*</span></span>
            <input id="zipcode" type="text" class="input" formControlName="zipcode" maxlength="10"
              autocomplete="off" data-testid="register-zip" />
            <div *ngIf="
                createAccount.get('location.zipcode')?.invalid &&
                (createAccount.get('location.zipcode')?.dirty ||
                  createAccount.get('location.zipcode')?.touched)
              ">
              <div *ngIf="createAccount.get('location.zipcode')?.errors?.['required']" class="error-message">
                Zip code is required.
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="create-form">
        <div class="form-control1">
          <span class="form-label">Password <span class="req">*</span></span>
          <input id="password" [type]="showPassword ? 'text' : 'password'" class="input" formControlName="password" style="margin-bottom: -0px"
            maxlength="50" autocomplete="disabled" (blur)="trimPassword()" data-testid="register-password" />
          <div class="show-password"
            (click)="togglePasswordVisibility()"
            data-testid="register-password-toggle">
            <span class="material-icons">{{!showPassword ? 'visibility' : 'visibility_off'}}</span>
          </div>
          <div *ngIf="
              createAccount.controls['password']?.invalid &&
              (createAccount.controls['password'].dirty ||
                createAccount.controls['password'].touched)
            ">
            <div *ngIf="createAccount.controls['password'].errors?.['required']" class="error-message">
              Password is required.
            </div>
            <div class="error-message" *ngIf="createAccount.controls['password']?.dirty">
              <span class="error-message"
                *ngIf="!createAccount.controls['password'].value?.match(passwordRegx)&&!createAccount.controls['password'].errors?.['required']">Password
                does not meet the requirements.</span>
            </div>
          </div>
        </div>
      </div>
      <div class="create-form">
        <div>
          <span class="form-label">
            Password is case sensitive and must be at least 8 characters
            long.<br />
            At least 1 <b>lowercase</b> letter.<br />
            At least 1 <b>uppercase</b> letter.<br />
            At least 1 <b>numeric</b> character.<br />
            At least 1 <b>special</b> character.
          </span>
        </div>
      </div>
      <div class="create-form">
        <div class="form-control1">
          <span class="form-label">Confirm Password <span class="req">*</span></span>
          <input id="confirmPassword" [type]="showConfirmPassword ? 'text' : 'password'" class="input" formControlName="confirmPassword" maxlength="50" (blur)="trimConfirmPassword()" data-testid="register-confirm" />
          <div class="show-password"
            (click)="toggleConfirmPasswordVisibility()"
            data-testid="register-confirm-toggle">
              <span class="material-icons">{{!showConfirmPassword ? 'visibility' : 'visibility_off'}}</span>
          </div>
          <div *ngIf="
              createAccount.controls['confirmPassword']?.invalid &&
              (createAccount.controls['confirmPassword'].dirty ||
                createAccount.controls['confirmPassword'].touched)
            ">
            <span class="error-message" *ngIf="createAccount.controls.confirmPassword.errors?.['required']">
              Please confirm your password.
            </span>
          </div>
          <span class="error-message" *ngIf="
              createAccount.controls['confirmPassword'].value != '' &&
              createAccount.controls['confirmPassword'].value !=
                createAccount.controls['password'].value
            ">
            Passwords do not match.
          </span>
        </div>
      </div>
      <hr />
      <span class="form-label"><span class="req">*</span> Indicates a required field.</span>
      <div class="re-captcha">
        <re-captcha [siteKey]="recaptchaSiteKey" (resolved)="onCaptchaResolved($event)" data-testid="register-recaptcha">
        </re-captcha>
      </div>
      <div class="panel-fields">
        <button type="button" class="btn btn-default" (click)="cancel()" data-testid="register-cancel">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" (click)="register()" [disabled]="isSubmitting" data-testid="register-submit">
          Submit
        </button>
      </div>
    </form>
  </div>
  <div class="footer">
    <hr />
    <div class="sm-text">
      We value your privacy and will not share your information with any other
      parties. <a href="https://www.cretelligent.com/privacy-policy/" target="_blank" data-testid="register-privacy-link">Click here</a> to view our privacy
      policy.
    </div>
  </div>
</div>